import { render } from "./ModalVerUsuario.vue?vue&type=template&id=b477e47e&scoped=true"
import script from "./ModalVerUsuario.vue?vue&type=script&lang=js"
export * from "./ModalVerUsuario.vue?vue&type=script&lang=js"

import "./ModalVerUsuario.vue?vue&type=style&index=0&id=b477e47e&scoped=true&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b477e47e"]])

export default __exports__